import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { StyledNameContainer } from "app/pages/sales-intelligence/pages/management/components/Management/styles";

export const StyledIntegrationSyncTimeWrapper = styled.div`
    ${StyledNameContainer} {
        ${setFontVariant("queryBar1", colorsPalettes.carbon[400])};
    }
`;
